// import  { useMemo }  from 'react';
import { SectionHeader /* , SelectableBoxField */ } from '@flos/react-ui';
import { shallowEqual /* , useDispatch */, useSelector } from 'react-redux';
// import { navigationActions } from '../store/navigation.slice';
import { useResourceBundle } from '../contexts/ResourceContext';
import useRefreshableScrollOnMount from '../hooks/useRefreshableScrollOnMount';
import { BookingOptionType, NavigationState } from '../store/navigation.type';
import { IState } from '../types';
import BookingSchedule from './BookingSchedule';
import CallYou from './CallYou';
import Confirmation from './Confirmation';
import ReviewInsuranceConsent from './ReviewInsuranceConsent';

// const bookingOptionUi: {
//     [key in BookingOptionType]: { label: string } | undefined;
// } = {
//     selectedTime: {
//         label: 'label.schedule.button.selected-time',
//     },
//     soonest: {
//         label: 'label.schedule.button.soonest',
//     },
// };

export interface BookingOptionPropType {
  autoScroll?: boolean;
  showConsent?: boolean;
}

const BookingOption = ({ autoScroll = true, showConsent = true }: BookingOptionPropType) => {
  // const dispatch = useDispatch();
  const selected = useSelector<IState, BookingOptionType>((state) => state.navigation.bookingOption);
  const resource = useResourceBundle();
  // const options = useMemo(
  //     () =>
  //         Object.entries(bookingOptionUi)
  //             .filter(([, value]) => value !== undefined)
  //             .map(([key, obj]) => {
  //                 const value = obj as NonNullable<typeof obj>;
  //                 return { label: resource[value.label], value: key };
  //             }),
  //     [resource]
  // );

  // const select = (name: string) => {
  //     dispatch(navigationActions.selectBookingType(name as BookingOptionType));
  // };

  const { bookingOption, bookingDate, bookingTime } = useSelector<IState, NavigationState>(
    (state) => state.navigation,
    shallowEqual
  );

  const scrollRef = useRefreshableScrollOnMount<HTMLDivElement>({}, bookingDate);

  const isScheduleValid = () => {
    if (bookingOption === 'selectedTime') {
      return !!bookingDate && !!bookingTime;
    }
    return true;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  };

  return (
    <div className="u-Space-up--lg">
      <div {...(autoScroll ? { ref: scrollRef } : {})}></div>
      <SectionHeader title={resource['label.schedule.header']} />
      {/* <SelectableBoxField options={options} value={selected} onChangeValue={select} maxWidth="wide" /> */}
      {selected === 'selectedTime' ? <BookingSchedule /> : <CallYou classNames={['u-Space-up', 'u-Space-down--lg']} />}
      {isScheduleValid() && (
        <>
          {showConsent ? <ReviewInsuranceConsent /> : null}
          <Confirmation valid />
        </>
      )}
    </div>
  );
};

export default BookingOption;
